import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { Box, Typography, Grid } from 'transfix-ui/core'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useBookableShipmentSavedSearchContext } from 'apps/fleet-planner/context/BookableShipmentSavedSearchContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import RecommendedShipmentsSection from '../../recommendations/RecommendedShipmentsSection'
import { SavedLanesSection } from '../../saved-lanes/SavedLanesSection'
import { BookableShipmentSavedSearchBidTile } from './BookableShipmentSavedSearchBidTile'
import { BookableShipmentSavedSearchRunItAgainSection } from './BookableShipmentSavedSearchRunItAgainSection'
import { BookableShipmentSavedSearchTruckTile } from './BookableShipmentSavedSearchTruckTile'

export const BookableShipmentSavedSearchAlertContainer = () => {
  const history = useHistory()
  const { trackEvent } = useFMSAnalytics()
  const { isSavedSearchesLoading } = useBookableShipmentSavedSearchContext()
  const { getFlag } = useFeatureFlagContext()
  const { enabled: fmsLaneRecommendations } = getFlag('fmsLaneRecommendations')
  const { enabled: enableFmsGraphqlRecs } = getFlag('enableFmsGraphqlRecs')

  const runItAgainTileClickHandler = () => {
    trackEvent('Book Load', 'CLICKED_VIEW_ALL_RUN_IT_AGAIN_LINK')
    history.push('/historical-lanes')
  }

  return (
    <Box pt={3} px={3}>
      <Grid container spacing={5}>
        {fmsLaneRecommendations && (
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <BookableShipmentSavedSearchTruckTile isLoading={isSavedSearchesLoading} />
              </Grid>
              <Grid item xs={6}>
                <BookableShipmentSavedSearchBidTile isLoading={isSavedSearchesLoading} />
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12}>
          <SavedLanesSection />
        </Grid>
        {enableFmsGraphqlRecs && (
          <Grid item xs={12}>
            <RecommendedShipmentsSection />
          </Grid>
        )}
        {!enableFmsGraphqlRecs && (
          <Grid item xs={12}>
            <Box display='flex' justifyContent='space-between'>
              <Typography variant='h3'>Run It Again</Typography>
              <Button
                data-test='view-all-run-it-again-btn'
                variant='text'
                color='tertiary'
                size='large'
                onClick={runItAgainTileClickHandler}>
                View All
              </Button>
            </Box>
            <BookableShipmentSavedSearchRunItAgainSection />
          </Grid>
        )}
      </Grid>
    </Box>
  )
}
